module.exports = "/wwwroot/img/instagram-brands.svg?ver=f994daad";